import { types } from "../types/types";

export const getInitialBalanceSidebar = (initialBalance) => ({
  type: types.initialBalanceSidebar,
  payload: initialBalance,
});

export const importInitialBalanceSidebar = (initialBalance) => {
  return async (dispatch) => {
    try {
      dispatch(getInitialBalanceSidebar(initialBalance));
    } catch (error) {
      console.error(error);
    }
  };
};
